import shieldLockIcon from "../../../../images/icons/shield-lock.svg";
import i18n from "../../../../utils/i18n";
import classes from "./cegjelzoSearch.module.scss";

const CegjelzoSecurityNotice = ({ hidden = false }) => (
  <div
    className={`${classes.securityBox} ${hidden ? classes.securityBoxHiddenOnFocus : ""}`}
  >
    <div className={classes.securityHeader}>
      <img
        src={shieldLockIcon}
        alt=""
        className={classes.securityIcon}
        width={20}
        height={20}
        aria-hidden="true"
      />
      <p className={classes.securityTitle}>{i18n.t("searchflow.securitytitle")}</p>
    </div>
    <p className={classes.securityDescription}>
      {i18n.t("searchflow.securitydescription")}
    </p>
  </div>
);

export default CegjelzoSecurityNotice;
